var React = require('react');

function SuccessIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#000","strokeWidth":"2","d":"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM7 12l4 3 5-7"}));
}

SuccessIcon.defaultProps = {"aria-label":"StatusGood","viewBox":"0 0 24 24","className":"StyledIcon-sc-ofa7kd-0 iJxtUR"};

module.exports = SuccessIcon;

SuccessIcon.default = SuccessIcon;
